"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

var _material = require("@mui/material");

var _Protraction = require("../Protraction");

var _utils = require("./utils");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTableRow = (0, _material.styled)(_material.TableRow, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "disabled";
  }
})(function (_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return {
    "&:hover": {
      background: disabled ? "unset" : undefined
    }
  };
});
var DataTableBody = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var staticRows = _ref2.staticRows,
      checkbox = _ref2.checkbox,
      parentCheckboxState = _ref2.parentCheckboxState,
      setParentCheckboxState = _ref2.setParentCheckboxState,
      _ref2$columns = _ref2.columns,
      columns = _ref2$columns === void 0 ? [] : _ref2$columns,
      rowGetter = _ref2.rowGetter,
      emptyText = _ref2.emptyText,
      onUpdateSearchSort = _ref2.onUpdateSearchSort,
      options = _ref2.options,
      linkRenderer = _ref2.linkRenderer,
      radio = _ref2.radio,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? "" : _ref2$search,
      _ref2$sortBy = _ref2.sortBy,
      sortBy = _ref2$sortBy === void 0 ? [] : _ref2$sortBy;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      rows = _useState2[0],
      setRows = _useState2[1];

  var _useState3 = (0, _react.useState)(staticRows ? false : true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLoadingRows = _useState4[0],
      setIsLoadingRows = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedValue = _useState6[0],
      setSelectedValue = _useState6[1];

  var _useState7 = (0, _react.useState)(new Set()),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      selectedValues = _useState8[0],
      setSelectedValues = _useState8[1];

  var isMounted = (0, _react.useRef)(false);
  var currentParentCheckboxState = (0, _react.useRef)(parentCheckboxState);
  var cellRendersOptions = (0, _react.useMemo)(function () {
    return (0, _lodash2.default)({}, _utils.defaultOptions, options);
  }, [options]);
  (0, _react.useEffect)(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _getRows = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setRows([]);
            setIsLoadingRows(true);
            _context.next = 4;
            return rowGetter({
              search: search,
              sortBy: sortBy
            });

          case 4:
            data = _context.sent;

            if (isMounted.current) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return");

          case 7:
            setRows(data);
            setIsLoadingRows(false);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [rowGetter, search, sortBy]); // Exposes methods to DataTable


  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getRows: function getRows() {
        // Do nothing if there is no rowGetter or no columns
        if (!columns.length || !rowGetter) return;

        _getRows();
      }
    };
  });
  (0, _react.useEffect)(function () {
    if (!columns.length || !rowGetter) return;
    var debounceGetRows = (0, _lodash.default)(_getRows, 250);
    debounceGetRows();
    return function () {
      debounceGetRows.cancel();
    };
  }, [_getRows, columns.length, rowGetter]);
  (0, _react.useEffect)(function () {
    if (onUpdateSearchSort) onUpdateSearchSort({
      search: search,
      sortBy: sortBy
    });
  }, [search, sortBy, onUpdateSearchSort]);
  (0, _react.useEffect)(function () {
    if (checkbox !== null && checkbox !== void 0 && checkbox.enabled && currentParentCheckboxState.current !== parentCheckboxState) {
      var _checkbox$callback;

      var newSelectedValues = new Set(selectedValues);

      if (parentCheckboxState === "checked") {
        (staticRows !== null && staticRows !== void 0 ? staticRows : rows).forEach(function (row) {
          return newSelectedValues.add(row.id);
        });
      } else if (parentCheckboxState === "unchecked") {
        newSelectedValues.clear();
      }

      setSelectedValues(newSelectedValues);
      (_checkbox$callback = checkbox.callback) === null || _checkbox$callback === void 0 ? void 0 : _checkbox$callback.call(checkbox, Array.from(newSelectedValues.values()));
      currentParentCheckboxState.current = parentCheckboxState;
    }
  }, [checkbox, parentCheckboxState, rows, selectedValues, staticRows]);
  var rowsAreEmpty = !(staticRows !== null && staticRows !== void 0 && staticRows.length || rows.length);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.TableBody, {
    children: [(staticRows !== null && staticRows !== void 0 ? staticRows : rows).map(function (row, rowIndex) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTableRow, {
        disabled: disabled,
        sx: row === null || row === void 0 ? void 0 : row.sx,
        children: [radio && radio.enabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Radio, {
            "aria-label": radio.ariaLabel // eslint-disable-next-line eqeqeq
            ,
            checked: selectedValue == row.id,
            color: "primary",
            disabled: disabled,
            onChange: function onChange(event) {
              var _radio$callback;

              setSelectedValue(event.target.value);
              (_radio$callback = radio.callback) === null || _radio$callback === void 0 ? void 0 : _radio$callback.call(radio, event.target.value);
            },
            size: "small",
            value: row.id
          })
        }), checkbox && checkbox.enabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Checkbox, {
            "aria-label": checkbox.ariaLabel,
            checked: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.has(row.id),
            onChange: function onChange(event) {
              var newSelectedValues = new Set(selectedValues);
              var newParentCheckboxState = parentCheckboxState;
              event.target.checked ? newSelectedValues.add(row.id) : newSelectedValues.delete(row.id);

              switch (newSelectedValues.size) {
                case 0:
                  newParentCheckboxState = "unchecked";
                  break;

                case (staticRows !== null && staticRows !== void 0 ? staticRows : rows).length:
                  newParentCheckboxState = "checked";
                  break;

                default:
                  newParentCheckboxState = "indeterminate";
              }

              if (newParentCheckboxState === currentParentCheckboxState.current) {
                var _checkbox$callback2;

                (_checkbox$callback2 = checkbox.callback) === null || _checkbox$callback2 === void 0 ? void 0 : _checkbox$callback2.call(checkbox, Array.from(newSelectedValues.values()));
              }

              setParentCheckboxState(newParentCheckboxState);
              setSelectedValues(newSelectedValues);
            },
            value: row.id
          })
        }), columns && columns.map(function (column) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
            children: typeof column.render === "function" ? column.render(_objectSpread(_objectSpread({}, row), {}, {
              disabled: disabled
            }), rowIndex) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Protraction.Protraction, {
              disabled: disabled,
              variant: "inherit",
              children: (0, _utils.formatCell)(column, row, cellRendersOptions)
            })
          }, column.id);
        }), linkRenderer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
          children: linkRenderer(_objectSpread(_objectSpread({}, row), {}, {
            disabled: disabled
          }))
        })]
      }, row.id);
    }), rowsAreEmpty && !isLoadingRows && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableRow, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
        align: "center",
        colSpan: columns === null || columns === void 0 ? void 0 : columns.length,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          children: emptyText
        })
      })
    }), isLoadingRows && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableRow, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableCell, {
        align: "center",
        colSpan: columns === null || columns === void 0 ? void 0 : columns.length,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
          size: 30
        })
      })
    })]
  });
});
var _default = DataTableBody;
exports.default = _default;